import React from 'react';
import { Link } from 'react-router-dom';
import { Home, List, Mail, Github, Plus } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-100 border-t mt-auto py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About section */}
          <div>
            <h3 className="text-lg font-semibold mb-3">Fitness App Search</h3>
            <p className="text-gray-600 text-sm">
              Discover the best fitness apps and tools for your specific needs,
              organized by categories, platforms, and sports.
            </p>
          </div>
          
          {/* Links section */}
          <div>
            <h3 className="text-lg font-semibold mb-3">Browse By</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/categories" className="text-blue-600 hover:text-blue-800 text-sm inline-flex items-center">
                  <List className="h-4 w-4 mr-1" />
                  Categories
                </Link>
              </li>
              <li>
                <Link to="/platforms" className="text-blue-600 hover:text-blue-800 text-sm inline-flex items-center">
                  <List className="h-4 w-4 mr-1" />
                  Platforms
                </Link>
              </li>
              <li>
                <Link to="/sports" className="text-blue-600 hover:text-blue-800 text-sm inline-flex items-center">
                  <List className="h-4 w-4 mr-1" />
                  Sports
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Contact section */}
          <div>
            <h3 className="text-lg font-semibold mb-3">More</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-blue-600 hover:text-blue-800 text-sm inline-flex items-center">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/submit-app" className="text-blue-600 hover:text-blue-800 text-sm inline-flex items-center">
                  Submit Tool
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-blue-600 hover:text-blue-800 text-sm inline-flex items-center">
                  Promote your listing
                </Link>
              </li>
              <li className="text-gray-600 text-sm inline-flex items-center">
                contact@fitnessappsearch.com
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t mt-6 pt-6 text-center text-gray-600 text-sm">
          <p>&copy; {new Date().getFullYear()} Fitness App Search. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
